





















































































import { Vue, Component, Prop, PropSync, Ref } from 'vue-property-decorator'
import DraftOption from '@/modules/draft/components/LeagueOfLegends/DraftOption'
import { DraftOptionEntity } from '@/api/draft'

export interface ChampionCategory {
  icon: any
  text: string
  tag: string
}

@Component({
  components: { DraftOption }
})
export default class DraftOptionGrid extends Vue {
  @Prop({ type: Array, default: [] })
  options!: DraftOptionEntity[]

  @PropSync('choice', { type: String, default: '' })
  draftOptionId!: string

  @Prop({ type: Array, default: [] })
  disabledIds!: string[]

  @Prop({ type: Boolean, default: false })
  disabled!: boolean

  @Prop({ type: Number, default: 0 })
  height!: number

  @Ref('grid')
  gridDiv!: HTMLDivElement

  category: string | null = null
  categories: ChampionCategory[] = []
  search: string = ''

  shouldDisable(draftOptionId: string) {
    return !!this.disabledIds.find(id => id === draftOptionId)
  }

  created() {
    this.categories = [
      {
        icon: require('@/assets/draft/wildrift_category/all.svg'),
        text: '全部',
        tag: 'all'
      },
      {
        icon: require('@/assets/draft/wildrift_category/mage.svg'),
        text: '法師',
        tag: 'Mage'
      },
      {
        icon: require('@/assets/draft/wildrift_category/support.svg'),
        text: '輔助',
        tag: 'Support'
      },
      {
        icon: require('@/assets/draft/wildrift_category/marksmen.svg'),
        text: '射手',
        tag: 'Marksman'
      },
      {
        icon: require('@/assets/draft/wildrift_category/tank.svg'),
        text: '坦克',
        tag: 'Tank'
      },
      {
        icon: require('@/assets/draft/wildrift_category/assassin.svg'),
        text: '刺客',
        tag: 'Assassin'
      },
      {
        icon: require('@/assets/draft/wildrift_category/fighter.svg'),
        text: '鬥士',
        tag: 'Fighter'
      }
    ]

    this.category = 'category-all'
  }

  mounted() {
    if (this.gridDiv) {
      this.gridDiv.addEventListener('scroll', this.onGridScroll)
    }
  }

  beforeDestroy() {
    if (this.gridDiv) {
      this.gridDiv.removeEventListener('scroll', this.onGridScroll)
    }
  }

  // iOS safari scroll freeze fix
  scrollTimer!: NodeJS.Timeout

  onGridScroll() {
    if (this.scrollTimer) {
      clearTimeout(this.scrollTimer)
    }

    this.scrollTimer = setTimeout(() => {
      this.gridDiv.scrollTop = Math.max(
        1,
        Math.min(
          this.gridDiv.scrollTop,
          this.gridDiv.scrollHeight - this.gridDiv.clientHeight - 1
        )
      )
    }, 300)
  }

  getOptionsByTag(tag: string) {
    return this.options.filter(
      option => tag === 'all' || option.tags.indexOf(tag) !== -1
    )
  }

  get getOptionsBySearch() {
    if (this.search === '') {
      return this.options
    }

    return this.options.filter(
      option =>
        option.name.indexOf(this.search) !== -1 ||
        option.icon
          .split('/')
          .slice(-1)[0]
          .toLowerCase()
          .indexOf(this.search.toLowerCase()) !== -1
    )
  }

  get gridHeight() {
    if (this.height <= 0) {
      return undefined
    }

    // 64 = tab height, 32 = margin
    return this.height - 64 - 24
  }
}
